import { Flex } from '@revenuemarket/cds';
import { colorTokens } from '@revenuemarket/design';
import { Modal, ModalProps, Typography } from 'antd';
import Image from 'next/image';

interface Props extends ModalProps {}

const ASTDownloadModal: React.FC<Props> = ({ ...props }) => {
  return (
    <Modal
      open={props.open}
      onCancel={props.onCancel}
      onOk={props.onOk}
      closable
      okText="다운로드"
      cancelText="취소"
    >
      <Flex
        gap={24}
        style={{
          padding: '8px 24px 12px 24px',
        }}
        justify="center"
        align="center"
        direction="column"
      >
        <Flex align="center">
          <Image
            alt="kb-icon"
            src="https://static.clobe.ai/image/kb-icon.png"
            width={24}
            height={24}
            style={{
              height: 24,
            }}
          />
          <span style={{ color: colorTokens.textDescription }}>..........</span>
          <Image
            alt="ast-icon"
            src="https://static.clobe.ai/image/ast-icon.png"
            width={28}
            height={28}
            style={{
              height: 28,
            }}
          />
        </Flex>
        <Typography.Title level={5}>보안프로그램을 설치합니다.</Typography.Title>
        <Flex direction="column" gap={4} align="center">
          <Typography.Text>AhnLab Safe Transaction</Typography.Text>
          <Typography.Text
            style={{
              color: colorTokens.textDescription,
            }}
          >
            Non-Active X 방식으로 이체 거래에 필요한 보안 기능을 제공합니다.{' '}
          </Typography.Text>
        </Flex>
        <Typography.Text>
          다운로드 버튼을 클릭하여 아래 프로그램 설치 후 브라우저를 새로고침해주세요.{' '}
        </Typography.Text>
      </Flex>
    </Modal>
  );
};

export default ASTDownloadModal;
